"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// // https://github.com/ericgio/react-bootstrap-typeahead/blob/master/docs/API.md#asynctypeahead
// Remote search component
var react_1 = require("react");
var react_bootstrap_typeahead_1 = require("react-bootstrap-typeahead");
var prop_types_1 = __importDefault(require("prop-types"));
var AsyncFilterableDropdownList = function (_a) {
    var fetchMethod = _a.fetchMethod, _b = _a.isDisabled, isDisabled = _b === void 0 ? false : _b, labelKey = _a.labelKey, _c = _a.allowCache, allowCache = _c === void 0 ? true : _c, handleSelectedItem = _a.handleSelectedItem, _d = _a.placeHolderValue, placeHolderValue = _d === void 0 ? "Search Item..." : _d;
    // Loading status while fetching data
    var _e = (0, react_1.useState)(false), isLoading = _e[0], setIsLoading = _e[1];
    // Full set of options, including any pre-selected options
    var _f = (0, react_1.useState)([]), options = _f[0], setOptions = _f[1];
    // Input query
    var _g = (0, react_1.useState)(""), query = _g[0], setQuery = _g[1];
    // Stores data so that future requests for that data can be served faster
    var _h = (0, react_1.useState)(new Map()), _cache = _h[0], set_cache = _h[1];
    // Select item
    var _j = (0, react_1.useState)(), selected = _j[0], setSelected = _j[1];
    // Fetch Data method
    var fetchData = function (searchQuery, page) {
        if (page === void 0) { page = 1; }
        return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fetchMethod(searchQuery, searchQuery + 1)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        error_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Handle search - callback
    var _handleSearch = (0, react_1.useCallback)(function (searchQuery) { return __awaiter(void 0, void 0, void 0, function () {
        var page, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    page = 1;
                    //  if (_cache.get(searchQuery)) {
                    //    var option: any = _cache.get(searchQuery);
                    //    setOptions({ options: option.options });
                    //    return;
                    //  }
                    setIsLoading(true);
                    return [4 /*yield*/, fetchData(searchQuery, page)];
                case 1:
                    response = _a.sent();
                    set_cache(new Map(_cache.set(searchQuery, __assign(__assign({}, response), { page: 1 }))));
                    setIsLoading(false);
                    setOptions(response);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    // Handle select - callback
    var _handleSelect = (0, react_1.useCallback)(function (selectedValue) {
        setSelected([selectedValue[0]]);
        if (selectedValue) {
            // Call back function to return the value to parent component
            handleSelectedItem(selectedValue[0]);
        }
        else {
            // Call back function to return the value to parent component
            handleSelectedItem(selectedValue[0]);
        }
    }, []);
    // Handle pagination - callback
    var _handlePagination = (0, react_1.useCallback)(function (e, shownResults) { return __awaiter(void 0, void 0, void 0, function () {
        var cachedQuery, page, response, cachedOptions;
        return __generator(this, function (_a) {
            cachedQuery = _cache.get(query);
            // Don't make another request if:
            // - the cached results exceed the shown results
            // - we've already fetched all possible results
            if (cachedQuery.options.length > shownResults ||
                cachedQuery.options.length === cachedQuery.total_count) {
                return [2 /*return*/];
            }
            setIsLoading(true);
            page = cachedQuery.page + 1;
            response = fetchData(query, page);
            cachedOptions = cachedQuery.options.concat(response);
            set_cache(new Map(_cache.set(query, __assign(__assign({}, cachedQuery), { cachedOptions: cachedOptions, page: page }))));
            setIsLoading(false);
            setOptions(response);
            return [2 /*return*/];
        });
    }); }, []);
    // Handle Input change
    var _handleInputChange = (0, react_1.useCallback)(function (text, event) {
        setQuery(text);
    }, []);
    // Bypass client-side filtering by returning `true`. Results are already
    // filtered by the search endpoint, so no need to do it again.
    var filterBy = function () { return true; };
    return ((0, jsx_runtime_1.jsx)(react_bootstrap_typeahead_1.AsyncTypeahead, { id: "async-filterable-drop-down", 
        // No need to filter
        filterBy: filterBy, 
        // Place holder text for the input.
        placeholder: placeHolderValue, 
        // Whether or not an asynchronous request is in progress.
        isLoading: isLoading, 
        // The labelKey prop specifies the string that will be used for searching and rendering options and selections.
        labelKey: labelKey, 
        // Callback to perform when the search is executed, where query is the input string.
        onSearch: _handleSearch, 
        // Options to be passed to the typeahead. Will typically be the query results, but can also be initial default options.
        options: options, 
        // Whether or not the component should cache query results.
        useCache: allowCache, 
        // Specify the size of the input.
        size: "small", 
        // handle selected item
        onChange: _handleSelect, 
        // Whether to disable the input.
        disabled: isDisabled, 
        // Invoked when the pagination menu item is clicked. Receives an event as the first argument and the number of shown results as the second.
        onPaginate: _handlePagination, 
        // Invoked when the input value changes. Receives the string value of the input (text), as well as the original event
        onInputChange: _handleInputChange, 
        // Message displayed in the menu when there are no valid results
        emptyLabel: "No matches found..." }));
};
// Component propTypes
AsyncFilterableDropdownList.propTypes = {
    fetchMethod: prop_types_1.default.func.isRequired,
    isDisabled: prop_types_1.default.bool,
    labelKey: prop_types_1.default.string.isRequired,
    allowCache: prop_types_1.default.bool,
    handleSelectedItem: prop_types_1.default.func.isRequired,
    placeHolderValue: prop_types_1.default.string,
};
exports.default = AsyncFilterableDropdownList;
